module.exports = __webpack_public_path__ + "c49115417f5d5f603c63f040a7e14ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/mythos-3.jpg
// module id = 809
// module chunks = 0